import { render } from "./ProgramServedReport.vue?vue&type=template&id=c576437c&ts=true"
import script from "./ProgramServedReport.vue?vue&type=script&lang=ts"
export * from "./ProgramServedReport.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\cst\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__